import { DROP_NONE } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/scope/issues/types';
import type { DropState } from './types';

export const initialDropState: DropState = {
	type: DROP_NONE,
};

export const HEADER_ROWS = 2;
